const BASE_URL = import.meta.env.VITE_BASE_URL;

export const getUserInfoUrl = `${BASE_URL}/v1/auth/me`;
